import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const styles = {
  fontFamily: "'Rubik', sans-serif;",
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
